import { Sector } from 'graphql-common';

interface Args {
  isFullAdmin: boolean;
  sectors?: Pick<Sector, 'readOnly'>[];
}

/**
 * Mirrors the API rule for saving a site without a sector: a non-full-admin
 * assigned to sectors must pick one, unless they are also assigned to the
 * read-only 'Other' sector (where sector-less sites land).
 *
 * The `sectors` query returns only a non-admin's own sectors, so an empty list
 * means they are scoped to sites (or not scoped at all) and the field stays
 * optional. Unrestricted users see every sector, 'Other' included.
 */
export default function getIsSiteSectorRequired({
  isFullAdmin,
  sectors,
}: Args): boolean {
  if (isFullAdmin || !sectors?.length) return false;
  return !sectors.some(({ readOnly }) => readOnly);
}
